<template>
  <div class="tree">
    <!-- <a-input-search
      class="ant-search"
      v-model:value="searchValue"
      style="margin-bottom: 8px"
      placeholder="搜索线路名称"
      @search="onSearch"
    /> -->
    <a-tree
      :show-line="true"
      :load-data="onLoadData"
      :tree-data="lineTree"
      :replace-fields="replaceFields"
      v-model:expanded-keys="expandedKey"
      @expand="expand"
      @select="select"
    >
    </a-tree>
  </div>
</template>
<script>
import { PlusSquareOutlined } from '@ant-design/icons-vue';
import { lineTree, bridgeTree, deviceTree } from "@/api/index/index.js";
import { bridgeList } from "@/api/project/project.js";

export default ({
  components: {
    PlusSquareOutlined,
  },
  data() {
    return {
      searchValue: '',
      query: {},
      lineTree: [],    //线路树形列表
      bridgeLists: [],
      bridgeTree: [],
      bridgeData: [],
      deviceTree: [],
      deviceData: [],
      replaceFields: {
        key: 'id',
        title: 'name'
      },
      expandedKey: [], //展开指定的树节点
      signData: {
        lineData: [],
        line: false,
        bridgeData: [],
        bridge: false,
        deviceData: [],
        device: false,
      }
    }
  },
  mounted() {
    lineTree(this.query).then(res => {
      if (res.code == 200) {
        this.lineTree = res.data
        this.signData.line = true
        this.signData.lineData = res.data
        // this.$emit('lineBridgeDevice', this.signData)
        for (let i = 0; i < this.lineTree.length; i++) {
          res.data[i].name = res.data[i].lineName  // 对应replaceFields
          res.data[i].id = res.data[i].lineId      // 对应replaceFields
          if (!this.lineTree[i].hasBride) { // 判断是否有下级
            this.lineTree[i].isLeaf = true
          }
          // 通过线路id请求桥梁树形数据
          bridgeTree({ lineId: this.lineTree[i].lineId }).then(res2 => {
            if (res2.code == 200) {
              for (let j = 0; j < res2.data.length; j++) {
                this.bridgeTree.push(res2.data[j])
              }
              if (i == this.lineTree.length - 1) {
                console.log(this.bridgeTree)
                this.signData.line = false
                this.signData.bridge = true
                this.signData.bridgeData = this.bridgeTree
                this.$emit('lineBridgeDevice', this.signData)
              }
            }
          })
        }
        // 先渲染线路 再渲染桥梁
        // var query = {
        //   pageNum: 1,
        //   pageSize: 100
        // }
        // bridgeList(query).then(res => { //桥梁列表
        // if (res.code == 200) {
        // if (res.data.list == 0) {
        // this.$message.success('没有数据');
        // }
        // this.bridgeLists = res.data.list
        // this.signData.line = false
        // this.signData.bridge = true
        // this.signData.bridgeData = this.bridgeLists
        // this.$emit('lineBridgeDevice', this.signData)
        // }
        // })
      }
    })
  },
  methods: {
    onSearch() {
      for (let i = 0; i < this.treeData.length; i++) {
        if (this.lineTree[i].lineName.indexOf(this.searchValue) > -1) {
          this.expandedKey.push(this.lineTree[i].lineId)
        }
      }
      console.log(this.expandedKey)
    },
    onLoadData(treeNode) {
      // console.log(treeNode)
      return new Promise(resolve => {
        if (treeNode.dataRef.children) {
          resolve();
          return;
        }
        if (treeNode.dataRef.lineId) { // 加载对应线路下的桥梁树形列表
          bridgeTree({ lineId: treeNode.dataRef.lineId }).then(res => {
            if (res.code == 200) {
              // this.bridgeTree = res.data
              for (let i = 0; i < res.data.length; i++) {
                res.data[i].name = res.data[i].bridgeName
                res.data[i].id = res.data[i].bridgeId
                if (!res.data[i].hasDevice) {
                  res.data[i].isLeaf = true
                }
              }
              this.bridgeData = res.data
              treeNode.dataRef.children = res.data
              this.lineTree = [...this.lineTree];
              resolve();
              // 大屏展示  报警信息联动
              this.$emit('alarmsMsg', treeNode.dataRef.lineId)
              //首页 展示桥梁图标
              // this.signData.line = false
              // this.signData.bridge = true
              // this.signData.bridgeData = this.bridgeData
              // this.$emit('lineBridgeDevice', this.signData)
            }
          }).catch(res => {
            console.log(res)
          });
        }
        if (treeNode.dataRef.brideId) { // 加载对应桥梁下的设备树形列表
          deviceTree({ bridgeId: treeNode.dataRef.brideId }).then(res => {
            if (res.code == 200) {
              // this.deviceTree = res.data
              for (let i = 0; i < res.data.length; i++) {
                res.data[i].name = res.data[i].deviceName + '丨' + res.data[i].location
                res.data[i].id = res.data[i].deviceId
                if (!res.data[i].hasDevice) {
                  res.data[i].isLeaf = true
                }
              }
              this.deviceData = res.data
              treeNode.dataRef.children = res.data
              this.lineTree = [...this.lineTree];
              resolve();
              //首页 展示设备图标
              // this.signData.line = false
              // this.signData.bridge = false
              // this.signData.device = true
              // this.signData.deviceData = this.deviceData
              // this.$emit('lineBridgeDevice', this.signData)
            }
          }).catch(res => {
            console.log(res)
          });
        }
      });
    },
    expand(selectedKeys, e) {
      // console.log(selectedKeys, e)
      if (e.node.dataRef.bridgeName) { //展示桥梁图片
        this.$emit('bridge-data', e.node.dataRef)
      }
      if (e.node.dataRef.bridgeTotal) { //首页 展示桥梁图标
        // this.signData.line = false
        // this.signData.bridge = true
        // this.signData.bridgeData = this.bridgeData
        // this.$emit('lineBridgeDevice', this.signData)
      }
      if (e.node.dataRef.productTotal) { //首页 展示设备图标
        // this.signData.line = false
        // this.signData.bridge = false
        // this.signData.device = true
        // this.signData.deviceData = this.deviceData
        // this.$emit('lineBridgeDevice', this.signData)
      }
    },
    select(selectedKeys, e) {
      console.log(selectedKeys, e)
      if (e.node.dataRef.lineId) {
        this.$emit('alarmsMsg', e.node.dataRef.lineId)
      }
      if (e.node.dataRef.bridgeName) {
        // 数据展示 展示桥梁图片
        this.$emit('bridge-data', e.node.dataRef)
      }
      if (e.node.dataRef.deviceUuid) {
        this.$emit('tree-event', e.node.dataRef) //产品详情
      }
    },
  }
});
</script>
<style scoped>
.tree {
  padding: 14px;
  border-radius: 12px;
  background: #fff;
}
.ant-tree {
  text-align: left;
}
.ant-search :deep() .ant-input-search-icon {
  color: #0088ff !important;
}
</style>
